import { render, staticRenderFns } from "./sinformation.vue?vue&type=template&id=6f282d5c&scoped=true&"
import script from "./sinformation.vue?vue&type=script&lang=js&"
export * from "./sinformation.vue?vue&type=script&lang=js&"
import style0 from "./sinformation.vue?vue&type=style&index=0&id=6f282d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f282d5c",
  null
  
)

export default component.exports